import SvgArrow from '@img/icons/arrow-right.svg';
import SvgExternal from '@img/icons/external.svg';
import { FocusRing } from '@react-aria/focus';
import * as React from 'react';
import S from './Button.styles';
const Button = ({ buttonType, buttonSize = 'default', children, icon, iconOnly, iconPosition = 'right', ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-type": buttonType, "data-button-size": buttonSize, ...otherProps },
            React.createElement(S.Text, null, children),
            React.createElement(S.IconWrapper, null, icon ?? React.createElement(SvgArrow, null)))));
};
const FakeButton = ({ buttonType, buttonSize = 'default', children, icon, iconOnly, iconPosition = 'right', ...otherProps }) => {
    return (React.createElement(S.Container, { as: "span", "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-type": buttonType, "data-button-size": buttonSize, ...otherProps },
        React.createElement(S.Text, null, children),
        React.createElement(S.IconWrapper, null, icon ?? React.createElement(SvgArrow, null))));
};
const LinkButton = ({ buttonType, buttonSize = 'default', children, icon, iconOnly, iconPosition = 'right', ...otherProps }) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: "a", "data-icon-only": iconOnly, "data-icon-position": iconPosition, "data-type": buttonType, "data-button-size": buttonSize, ...otherProps },
            React.createElement(S.Text, null, children),
            React.createElement(S.IconWrapper, null, (icon ?? otherProps.target === '_blank') ? React.createElement(SvgExternal, null) : React.createElement(SvgArrow, null)))));
};
export { FakeButton, LinkButton, Button as default };
